export default __webpack_public_path__ + "static/media/ken.c4fbe93b.jpeg";